var _path, _path2, _circle, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 122,
    viewBox: "0 0 112 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.253397,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9026 86.6113C19.9026 86.6113 20.4609 83.5277 22.6562 90.7789C24.8515 98.0301 49.6751 113.901 57.9846 101.048C66.2941 88.1947 78.042 102.617 86.1571 98.76C94.2723 94.9026 95.5577 89.8117 89.5089 77.545C83.46 65.2783 98.3393 50.3308 83.5074 40.7211C68.6754 31.1113 80.1577 33.4721 80.1577 33.4721L80.0821 72.7056L60.2282 90.7053L19.9026 86.6113Z",
    fill: "url(#paint0_linear_270_2342)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7675 48.4239C78.7675 48.4239 77.043 48.3235 80.862 46.6129C84.681 44.9022 91.6908 30.0501 84.0995 26.3124C76.5082 22.5746 83.6069 15.0763 80.9499 10.8354C78.2929 6.59452 75.4212 6.22706 69.118 10.4166C62.8148 14.6062 50.6546 3.41626 46.3967 12.2989C42.1388 21.1816 49.3713 10.3971 49.3713 10.3971L67.1056 15.9761L78.2903 25.77L78.7675 48.4239Z",
    fill: "url(#paint1_linear_270_2342)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8381,
    cy: 52.6061,
    r: 38.8381,
    stroke: "#F7931A",
    strokeOpacity: 0.4,
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2094 13.857C51.4863 13.1598 61.6192 16.5737 69.379 23.3475C77.1389 30.1214 81.89 39.7004 82.5872 49.9773C83.2843 60.2542 79.8705 70.3871 73.0966 78.147C66.3228 85.9068 56.7437 90.6579 46.4669 91.3551",
    stroke: "url(#paint2_linear_270_2342)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_270_2342",
    x1: 22.8958,
    y1: 49.3931,
    x2: 139.211,
    y2: 92.3987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A374E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_270_2342",
    x1: 57.44,
    y1: 49.0848,
    x2: 73.6582,
    y2: -18.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A374E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_270_2342",
    x1: 48.2219,
    y1: -5.03294,
    x2: 53.1685,
    y2: 150.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7931A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A374E",
    stopOpacity: 0.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.a57ee392591725c017f095f390a39f3c.svg";
export { ForwardRef as ReactComponent };